import { OverlayApi } from '../api/overlay-api';

export const OverlayService = {
  createNewSession: async () => {
    try {
      const response = await OverlayApi.createNewSession({});
      return response.data.conversation;
    } catch (error) {
      console.error('Failed to create new session:', error);
      throw error;
    }
  },
  Feedback: async (rating, feedback_text) => {
    try {
      const response = await OverlayApi.submitFeedback(rating, feedback_text);
      console.log('the response for the rating', response);
      return response;
    } catch (error) {
      console.error('failed to sub,it the response', error);
      throw error;
    }
  },
  fetchAllConversations: async () => {
    try {
      const response = await OverlayApi.getAllConversations(); // calls API
      return response.conversation || []; // returns an array of conversations
    } catch (error) {
      console.error('Failed to fetch conversations:', error);
      throw error;
    }
  },
  updateConversation: async (conversation_id, actiontype, title) => {
    console.log('conversatio id1', conversation_id);
    console.log('action type passed1', actiontype);
    console.log('title value passed1', title);

    let payload = {};

    if (actiontype === 'rename') {
      payload.title = title;
    } else if (actiontype === 'archive') {
      payload.isarchived = true;
    }

    try {
      const response = await OverlayApi.updateConversation(
        conversation_id,
        payload
      );
      return response;
    } catch (error) {
      console.error('failed to update the conversation', error);
      throw error;
    }
  },

  deleteOneConversation: async (conversation_id) => {
    console.log('conversation id we are passing here', conversation_id);
    try {
      const response = await OverlayApi.deleteOne(conversation_id);
      console.log('deleting the one conversation ', response);
      return response;
    } catch (error) {
      console.error('failed to delete the conversation', error);
      throw error;
    }
  },
  fetchConversation: async (conversation_id) => {
    console.log('conversation id passed to fetchconversation', conversation_id);
    try {
      const response = await OverlayApi.fetchConversation(conversation_id);
      return response;
    } catch (error) {
      console.error('failed to fetch the conversation', conversation_id);
      throw error;
    }
  },
};
